import React from "react";
import { AIThumbsUpThumbsDownFeedbackForm } from "@src/features/shared/AIThumbsUpThumbsDownFeedbackForm";

interface AskOpusFeedbackProps {
  vercelChatMessageId: string;
}

export const AskOpusFeedback: React.FC<AskOpusFeedbackProps> = ({
  vercelChatMessageId,
}) => {
  return (
    <AIThumbsUpThumbsDownFeedbackForm
      feedbackInput={{ vercelChatMessageId }}
      showPromptText={false}
      positiveFeedbackPrompt="Great! Tell me what you liked."
      negativeFeedbackPrompt="Help me improve. What could I do better?"
    />
  );
};
